exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".com-point[data-v-2c915dea]{width:6px;height:6px;border-radius:1px}.com-point__required[data-v-2c915dea]{background:#fa8c16}.com-point__mapping[data-v-2c915dea]{background:#52c41a}.com-point__veto[data-v-2c915dea]{background:#f5222d}.com-point__bonus[data-v-2c915dea]{background:#36cfc9}\n", ""]);

